import moment from 'moment';

import { RouteItemStateType } from '~globals/types/enums';
import { ItemFilterV2Base } from '~services/item/types';
import { formatterDate } from '~utils/formatter';

import { DEFAULT_FILTERS_STATE } from '../../../FinalizedFiltersContext';

export const ITEM_KEY_ID = 'itemId';

export const DEFAULT_PAGINATION = {
  page: 1,
  sizePerPage: 50,
};

export const DEFAULT_ROUTE_ITEM_STATES: RouteItemStateType[] = [
  RouteItemStateType.FinalizedSuccess,
  RouteItemStateType.FinalizedError,
  RouteItemStateType.WithoutVisiting,
];

export const DEFAULT_FILTERS_PAYLOAD: ItemFilterV2Base = {
  routeCode: null,
  maxDeliveredDateTimeFrom: null,
  maxDeliveredDateTimeTo: null,
  includeWithoutMaxDeliveryDatetime: null,
  dateFrom: null,
  dateTo: null,
  finalizedDateTimeFrom: formatterDate(
    DEFAULT_FILTERS_STATE.finalizedDateTimeFrom,
    { format: moment.HTML5_FMT.DATETIME_LOCAL_MS },
  ),
  finalizedDateTimeTo: formatterDate(
    DEFAULT_FILTERS_STATE.finalizedDateTimeTo,
    {
      format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
    },
  ),
  unit1GraterThan: null,
  unit1LowerThan: null,
  unit2GraterThan: null,
  unit2LowerThan: null,
  priceGraterThan: null,
  priceLowerThan: null,
  vehiclesId: null,
  driversId: null,
  serviceTypeList: null,
  zonesId: null,
  assignedUserId: null,
  sourceImportTypeIds: null,
  routeItemStateTypesId: DEFAULT_ROUTE_ITEM_STATES,
  collectItemStateTypesId: [],
};
